import React from "react";
import { connect } from "react-redux";
import {
  useHistory,
  withRouter,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import moment from 'moment';
import * as _ from "lodash";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import RoomIcon from "@material-ui/icons/Room";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import NotificationsIcon from "@material-ui/icons/Notifications";
import AssessmentIcon from "@material-ui/icons/Assessment";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import AddIcon from "@material-ui/icons/Add";
import AdjustIcon from "@material-ui/icons/Adjust";
import CheckIcon from "@material-ui/icons/Check";
import ScheduleIcon from "@material-ui/icons/Schedule";
import MenuIcon from "@material-ui/icons/Menu";
import MapIcon from "@material-ui/icons/Map";
import HelpIcon from "@material-ui/icons/Help";
import PeopleIcon from "@material-ui/icons/People";
import DescriptionIcon from "@material-ui/icons/Description";
import GavelIcon from "@material-ui/icons/Gavel";
import ListAltIcon from "@material-ui/icons/ListAlt";
import Button from "@material-ui/core/Button";
import InfoIcon from '@material-ui/icons/Info';
import Services from "../api/api";
import { withTranslation, Trans } from "react-i18next";
import { Link } from "react-router-dom";
import Zoom from "@material-ui/core/Zoom";
import Loader from "./loaders/loader";
import imgUrl from '../assets/images/imageUrl.js';
import SettingsIcon from '@material-ui/icons/Settings';
import ApiServices from "../api/api";
import {
  setSelectedComponentObject,
  resetSelectedCompnentObject,
  setBottomNavComponentObject,
  setcomponentbgcolor
} from "../redux/actions/appActions";
import OffileDb from "../config/pouchDB";
import { db, storageRef } from "../service/firebase"
import annyang from 'annyang';
import "../assets/css/flat.css";
// import SpeechKITT from 'speechkitt';
import Artyom from 'artyom.js';
import swal from "sweetalert";
import Grid from '@material-ui/core/Grid';
import { Widget, addResponseMessage, addUserMessage } from 'react-chat-widget';
import 'react-chat-widget/lib/styles.css';
import logo from '../assets/images/kira.png'
import CancelIcon from '@material-ui/icons/Cancel';

// const Jarvis = new Artyom();

const checked = false;
var count = 0

class HomeMenuList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      open: false,
      checked: false,
      phrases: [],
      triggerWords: [],
      emergencyContactsList: {},
      translationLabel: {},
      QAphrases: [],
      micActive: false,
      botResponse: '',
      showBotText: false,
      menuList: [],
      bglogo: imgUrl.logo,
      botLocale: '',
      botUrl: '',
      showBot: false,
      botInitialized: false,
      surveyList: [],
      serviceDetails: [],
      sectionDetails: [],
      formObj: {},
      surveyLength: 0,
      messageType: '',

    };
    this.handleClick = this.handleClick.bind(this);
    this.speakText = this.speakText.bind(this);
    this.speakTextRussian = this.speakTextRussian.bind(this);
    this.getEmergencyContacts = this.getEmergencyContacts.bind(this);
  }

  componentDidMount() {
    OffileDb.setDatabase();
    this.getTranlation(this.props.langId);
    this.getEmergencyContacts();
    this.getAppLogos();
    var that = this;
    this.updateFcmId();
    // setTimeout(function () {
    //   this.setState({ checked: false });
    // }, 0);
    this.props.resetSelectedCompnentObject();
    // if(annyang && localStorage.getItem('isGreeted')=="true"){
    //   window.SpeechKITT.hide();
    // }

    this.isVoiceBotEnabled();
    if (navigator.onLine) {
      this.getSurveyDetails();
    }
  }

  getSurveyDetails() {
    var param = {
      communityId: this.props.communityuid,
      languageId: parseInt(this.props.langId)
    };
    ApiServices.getSurveyByCommunityId(param).then((res) => {
      try{
        if (res.data.data.length > 0) {
          console.log("survey ID::", res.data.data)
          this.setState({ surveyList: res.data.data });
          OffileDb.setData('surveyList', res.data.data);

          this.getSectionBySurveyId(res.data.data[0])
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }

  getSectionBySurveyId(obj) {
    this.setState({ isSectionEnabled: obj.isSectionEnabled })
    if (navigator.onLine) {
      var param = {
        communityId: obj.communityId,
        languageId: this.props.langId,
        surveyId: obj.id,
      };

      ApiServices.getSectionBySurveyId(param).then((res) => {
        try{
          if (res.data.data.length > 0) {
            this.setState({
              sectionDetails: res.data.data[0],
              isLoading: false,
            });
            this.getQuestionsBySurveyId(res.data.data[0]);
          }
        }catch(err){
          console.log("err::", err)
        }
      });
    } else {
      this.loadOfflineData(obj.id)
    }
  }

  getQuestionsBySurveyId(obj) {

    if (navigator.onLine) {
      var localid = "surveyDetails" + obj.surveyId
      var param = {
        communityId: obj.communityId,
        languageId: this.props.langId,
        sectionId: obj.id,
        surveyId: obj.surveyId
      };

      ApiServices.getSurveySectionQuestionsBySectionId(param).then((res) => {
        try{
          if (res.data.data.length > 0) {

            this.setState({
              serviceDetails: res.data.data,
              surveyLength: res.data.data.length,
              isLoading: false,
            });
            OffileDb.setData(localid, res.data.data)
            //this.loadOfflineSurveyForm(obj)
          }
        }catch(err){
          console.log("err::", err)
        }
      });
    } else {
      this.loadOfflineData(obj.surveyId)
    }
  }

  askSurveyQuestion(i) {
    var that = this;
    var optionStr = "";
    var optionObj = {};
    optionObj = that.state.serviceDetails[i].questionnaire[0].optionMap;
    console.log("keshika", optionObj)
    optionStr = Object.values(optionObj).join(", ");
    if (Object.values(optionObj).length == 0) {
      that.speakText(that.state.serviceDetails[i].questionnaire[0].title);
    } else {
      that.speakText(that.state.serviceDetails[i].questionnaire[0].title + " " + "Your options are: " + optionStr);
    }
    console.log(that.state.serviceDetails[i].questionnaire[0].title + " " + "Your options are: " + optionStr);
    that.stopRecognition();
  }

  verifyUserResponse(i, str) {
    var that = this;
    str = str.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()'’]/g, "");
    str = str.replace(/\s{2,}/g, " ");
    var res = false;
    var optionObj = {};
    var optionArr = [];
    var lowerCaseOptionArr = [];
    var counter = 0;
    optionObj = that.state.serviceDetails[i].questionnaire[0].optionMap;
    optionArr = Object.values(optionObj);
    for (var ele of optionArr) {
      var temp = ele.toLowerCase();
      temp = temp.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()'’]/g, "");
      temp = temp.replace(/\s{2,}/g, " ");
      lowerCaseOptionArr[counter] = temp;
      counter++;
    }
    res = lowerCaseOptionArr.includes(str);
    console.log("Verify me::", str)
    console.log("Verify me::", lowerCaseOptionArr)
    console.log("Verify me::", res)
    if (lowerCaseOptionArr.length == 0) {
      return true;
    } else {
      return res;
    }
  }

  getOptionValue(i, str) {
    var that = this;
    str = str.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()'’]/g, "");
    str = str.replace(/\s{2,}/g, " ");
    var res = false;
    var optionObj = {};
    var optionArr = [];
    var lowerCaseOptionArr = [];
    var counter = 0;
    optionObj = that.state.serviceDetails[i].questionnaire[0].optionMap;
    optionArr = Object.values(optionObj);
    for (var ele of optionArr) {
      var temp = ele.toLowerCase();
      temp = temp.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()'’]/g, "");
      temp = temp.replace(/\s{2,}/g, " ");
      lowerCaseOptionArr[counter] = temp;
      counter++;
    }
    if (lowerCaseOptionArr.length == 0) {
      return str;
    } else {
      for (var i = 0; i < lowerCaseOptionArr.length; i++) {
        if (str == lowerCaseOptionArr[i]) {
          console.log("test", optionArr[i])
          return ("option_" + (i + 1));
        }
      }
    }
  }

  handleSubmit(obj) {
    const { t } = this.props;
    let { lat, lng } = this.state;
    let serviceDetails = _.cloneDeep(this.state.serviceDetails);
    let { communityuid, langId } = this.props;
    var formObj = obj;
    let questionnaireArr = [];
    var questionarr = [];

    serviceDetails.forEach(obj => {
      questionarr = [...questionarr, ...obj.questionnaire]
    })

    questionarr.forEach((qobj) => {
      var id = qobj.id
      var value = formObj[id] != undefined ? formObj[id] : '';
      qobj.response = {
        value: Array.isArray(value) ? value : [value]
      }
      qobj.responseExtension = {};
      // if (qobj.dependentQuestionsList.length > 0) {
      //   this.checkDependentResponsed(qobj, formObj)
      // }
      questionnaireArr.push(qobj);
    })

    var now = new Date();
    let params = {
      communityId: communityuid,
      languageId: langId,
      questionResponse: questionnaireArr,
      sectionId: serviceDetails[0].sectionId,
      surveyId: serviceDetails[0].surveyId,
      offlineDate: this.state.offlineDate != '' && this.state.offlineDate ? this.state.offlineDate : moment(now).format('YYYY-MM-DD HH:mm:ss'),
      userDetails: {
        location: {
          coordinates: [lat, lng],
        },
        serialNumber: localStorage.getItem("deviceuuid"),
      },
      userId: JSON.parse(localStorage.getItem("obj")).userId,
    };
    console.log(params);
    if (Object.keys(formObj).length != 0) {
      this.submitApiData(params)
    }
  }

  increaseSurveyCount() {
    let { communityuid } = { ...this.props };
    let channel = `${communityuid}/survey/`;

    let data = {
      timestamp: Date.now(),
      communityid: communityuid,
      userid: JSON.parse(localStorage.getItem("obj")).userId,
      elType: 'survey'
    };

    db.ref(channel).push(data);
  }

  submitApiData(params) {
    const { t } = this.props;
    const { tablist } = this.props;
    var self = this;
    ApiServices.addCaseSetForSurveyUsingPOST(params).then((res) => {
      try{
        if (res.data.status == 200) {
          this.increaseSurveyCount();
          swal({
            text: t("Thank you for your response"),
            icon: "success",
            button: t("ok"),
          }).then((val) => {
            // if (self.state.inlineForm) {
            //   if (tablist.length == 1) {
            self.props.history.push("/layout");
            //   } else {
            //     self.props.handleChangeIndex(1);
            //   }
            // } else {
            //   self.props.history.push("/layout/survey");
            // }

          });
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }

  fakeStartRecognition() {
    if (window.cordova) {
      var STTSettings = {
        language: localStorage.getItem('i18nextLng').split('_').join('-'),
        showPopup: false
      };
      var that = this;
      console.log("this.botInitialized", that.state.botInitialized);
      if (that.state.botInitialized == false) {
        console.log("that.state.botInitialized2", that.state.botInitialized);
        that.setState({
          botInitialized: true
        })

        window.plugins.speechRecognition.hasPermission(function (isGranted) {
          if (isGranted) { } else {
            window.plugins.speechRecognition.requestPermission(function () {


            }, function (err) {
              console.log(err);
            })
          }
        });
        window.plugins.speechRecognition.startListening(function (phrases) {


        }, function (err) {
          console.error(err);
        }, STTSettings);

      } else {

      }
    }
  }

  speakText(text) {
    var that = this;
    var speechRate = 1;
    if(window.cordova && window.cordova.platformId == 'ios'){
      speechRate = 1.5;
    }
    console.log("text", text);
    that.stopRecognition();
    console.log("this.state.botLocale", this.state.botLocale);
    // annyang.abort();
    // let self = this;

    if (window.cordova) {
      document.addEventListener('deviceready', function () {
        window.TTS.speak(
          {
            text: text,
            locale: localStorage.getItem('i18nextLng').split('_').join('-'),
            // voiceType: 'Female',
            rate: speechRate,
            // cancel: false
          }, function () {
            console.log("text::", text);
            that.setState({ micActive: false });
            // annyang.abort();
          }, function (reason) {
            alert(reason);
          });
      })
    } else {
      // Jarvis.say(text, {
      //   onEnd() {
      //     // annyang.abort();
      //   }
      // });
    }
  }

  speakTextRussian(text) {
    console.log("text", text);
    // annyang.abort();
    // let self = this;
    if (window.cordova) {
      document.addEventListener('deviceready', function () {
        window.TTS.speak({ text: text, locale: 'ru-RU' }, function () {
          console.log("text::", text);
          // annyang.abort();
        }, function (reason) {
          alert(reason);
        });
      })
    } else {
      // Jarvis.say(text, {
      //   onEnd() {
      //     // annyang.abort();
      //   }
      // });
    }
    // this.toggleAnnyang();
  }

  stopRecognition() {
    var that = this;
    console.log("stopRecognition");
    if (window.cordova) {
      window.plugins.speechRecognition.stopListening(function () {
        that.setState({ micActive: false });
        console.log("stopRecognition", that.state.micActive);

        // No more recognition
        // window.SpeechKITT.abortRecognition();
      }, function (err) {
        console.log(err);
      });
    }
  }

  startRecognition() {
    console.log("startRecognition");
    if (window.cordova) {
      window.TTS.speak("");
      var STTSettings = {
        language: localStorage.getItem('i18nextLng').split('_').join('-'),
        showPopup: false
      };
      var that = this;
      window.plugins.speechRecognition.hasPermission(function (isGranted) {
        if (isGranted) {
          window.plugins.speechRecognition.startListening(function (phrases) {
            that.setState({ micActive: true });
            console.log("startRecognition", that.state.micActive);

            if (phrases != null && phrases.length > 0) {
              var message = phrases[0].toLowerCase();
              phrases[0] = message;
              console.log('Speech recognized : ' + phrases[0]);
              var triggerFlag = false;
              var triggerQAFlag = false;
              var triggerWords = that.state.triggerWords;
              var surveyTriggerWords = ["survey"];

              for (var str of triggerWords) {
                if (phrases[0].includes(str)) {
                  triggerFlag = true;
                }
              }
              for (var str of surveyTriggerWords) {
                if (phrases[0].includes(str)) {
                  if (!localStorage.getItem('botSQ')) {
                    localStorage.setItem('botSQ', 0);
                  } if (!localStorage.getItem('awaitAnswer')) {
                    localStorage.setItem('awaitAnswer', false);
                  } if (!localStorage.getItem('botSA')) {
                    localStorage.setItem('botSA', '{}');
                  }
                }
              }

              var QAphrases = [];
              var AllQAphrases = [];
              that.state.phrases.map((comp) => {
                QAphrases.push(comp.talkBackBasedOnQuestions)
              })


              var QAphrases = [];
              var AllQAphrases = [];
              that.state.phrases.map((comp) => {
                QAphrases.push(comp.talkBackBasedOnQuestions)
              })


              console.log("QAphrases", QAphrases);
              for (var str of QAphrases) {
                AllQAphrases.push(str);
                console.log("PString", str)
                console.log("Object str", Object.keys(str))
                console.log("Phrases", phrases[0]);
              }
              var myAllQAphrases = Object.assign({}, ...AllQAphrases);
              for (var i in myAllQAphrases) {
                myAllQAphrases[i.toLowerCase()] = myAllQAphrases[i];
                delete myAllQAphrases[i];
              }
              console.log("myAllQAphrases", myAllQAphrases);
              if (Object.keys(myAllQAphrases).includes(phrases[0])) {
                triggerQAFlag = true;
              }
              console.log(QAphrases)
              console.log("triggerQAFlag", triggerQAFlag)
              console.log("AllQAphrases", AllQAphrases)

              that.setState({
                QAphrases: myAllQAphrases,
              });

              if (triggerFlag === true) {
                let list = that.state.menuList;
                console.log("keshika menulist::", list)
                list.map((menu) => {
                  if (menu.visible) {
                    console.log("keshika getPhrases::", that.state.phrases)
                    that.state.phrases.map((comp) => {
                      console.log("comp::", comp);
                      console.log("menu::", menu);
                      if (comp.componentId == menu.componentId) {
                        console.log("keshika comp.componentId == menu.componentId::", comp.componentId == menu.componentId)
                        for (var str of comp.phrases) {
                          console.log("str", str);
                          str = str.toLowerCase();
                          console.log("str2", str);
                          console.log("phrases", phrases);
                          console.log("comp.phrases", comp.phrases);
                          console.log("str", str);
                          console.log("phrases[0]", phrases[0]);
                          console.log("phrases[0].includes(str)", phrases[0].includes(str));
                          if (phrases[0].includes(str)) {
                            console.log("menu.path", menu.path);
                            that.props.setSelectedComponentObject({ id: menu.componentId, name: menu.name });
                            that.props.setBottomNavComponentObject({ id: menu.componentId, name: menu.name });
                            if (localStorage.getItem("templateID") == 2) {
                              that.props.history.push("/layout2/" + menu.path);
                            } else {
                              console.log(menu)
                              if (menu.path == "information") {
                                console.log("inside information");
                                // that.props.setSelectedComponentObject({ name: "Get Information", id: 51 });
                                // that.props.setBottomNavComponentObject({ name: "Get Information", id: 51 });
                                if (localStorage.getItem("templateID") == 2) {
                                  that.props.history.push("/layout2/" + menu.path);
                                } else {
                                  that.props.history.push("/layout/" + menu.path);
                                }
                              } else {
                                that.props.history.push("/layout/" + menu.path);
                              }
                            }
                            let pageInfo = "There you go!";
                            if (comp.freeText) {
                              pageInfo = comp.freeText;
                            }
                            that.speakText(pageInfo);
                            break;
                          }
                        }
                      }
                    })
                  } else {
                    menu.childs.map((submenu) => {
                      console.log("submenu", submenu);
                      if (submenu.visible) {
                        that.state.phrases.map((comp) => {
                          console.log("comp2::", comp);

                          // hard coded please remove later
                          // if(submenu.componentId == 51){
                          //   comp.componentId = 51
                          // }

                          if (comp.componentId == submenu.componentId) {
                            for (var str of comp.phrases) {
                              str = str.toLowerCase();
                              if (phrases[0].includes(str)) {
                                console.log("submenu", submenu);
                                that.props.setSelectedComponentObject({ id: submenu.componentId, name: submenu.name });
                                that.props.setBottomNavComponentObject({ id: submenu.componentId, name: submenu.name });
                                if (localStorage.getItem("templateID") == 2) {
                                  that.props.history.push("/layout2/" + submenu.path);
                                } else {
                                  console.log("submenu.path", submenu.path);
                                  if (submenu.path == "getknowledgeable") {
                                    console.log("inside information");
                                    // that.props.setSelectedComponentObject({name: "Information", id: 51, componentbgcolor: "#2366a7"});
                                    // that.props.setBottomNavComponentObject({name: "Information", id: 51, componentbgcolor: "#2366a7"});
                                    if (localStorage.getItem("templateID") == 2) {
                                      that.props.history.push("/layout2/getknowledgeable");
                                    } else {
                                      that.props.history.push("/layout/getknowledgeable");
                                    }
                                  } else {
                                    console.log("inside else");
                                    that.props.history.push("/layout/" + submenu.path);
                                  }
                                  let pageInfo = "There you go!";
                                  if (submenu.freeText) {
                                    pageInfo = submenu.freeText;
                                  }
                                  that.speakText(pageInfo);
                                  break;
                                }
                                break;
                              }
                            }
                          }
                        })
                      }
                    });
                  }
                })

                if (phrases[0].includes("setting")) {
                  if (localStorage.getItem("templateID") == 2) {
                    that.props.history.push({ pathname: `/layout2/settings`, name: "Settings" });
                  } else {
                    that.props.history.push({ pathname: `/layout/settings`, name: "Settings" });
                  }
                  that.speakText("There you go!")
                } else if (phrases[0].includes("home")) {
                  localStorage.setItem('BotInnit', "true");
                  if (localStorage.getItem("templateID") == 2) {
                    that.props.history.push("/layout2");
                  } else {
                    that.props.history.push("/layout");
                  }
                  that.speakText("You're back on the Homepage.")

                } else if (phrases[0].includes("back")) {
                  switch (that.props.history.location.pathname) {
                    case '/layout/knowyourrights':
                      if (localStorage.getItem("templateID") == 2) {
                        localStorage.setItem('BotInnit', "true");
                        that.props.history.push("/layout2");
                      } else {
                        that.props.history.push("/layout");
                      }

                      break;
                    case '/layout/getknowledgeable':
                      console.log("getknowledgeable");
                      if (localStorage.getItem("templateID") == 2) {
                        localStorage.setItem('BotInnit', "true");
                        that.props.history.push("/layout2");
                      } else {
                        that.props.history.push("/layout");
                      }

                      break;
                    case '/layout/information':
                      console.log("information")
                      if (localStorage.getItem("templateID") == 2) {
                        localStorage.setItem('BotInnit', "true");
                        that.props.history.push("/layout2");
                      } else {
                        that.props.history.push("/layout");

                      }

                      break;
                    case '/layout/nearme':
                      if (localStorage.getItem("templateID") == 2) {
                        localStorage.setItem('BotInnit', "true");
                        that.props.history.push("/layout2");
                      } else {
                        that.props.history.push("/layout");
                      }

                      break;
                    case '/layout/peerchat':
                      if (localStorage.getItem("templateID") == 2) {
                        localStorage.setItem('BotInnit', "true");
                        that.props.history.push("/layout2");
                      } else {
                        that.props.history.push("/layout");
                      }

                      break;
                    case '/layout/services':
                      if (localStorage.getItem("templateID") == 2) {
                        localStorage.setItem('BotInnit', "true");
                        that.props.history.push("/layout2");
                      } else {
                        that.props.history.push("/layout");
                      }

                      break;
                    default:
                      that.props.history.goBack();
                      break;
                  }
                  that.speakText("Alright!");
                } else if (phrases[0].includes("basic")) {
                  that.props.setSelectedComponentObject({ name: "Get Information", id: 51 });
                  that.props.setBottomNavComponentObject({ name: "Get Information", id: 51 });
                  if (localStorage.getItem("templateID") == 2) {
                    that.props.history.push("/layout2/getknowledgeable");
                  } else {
                    that.props.history.push("/layout/getknowledgeable");
                  }
                  that.speakText("You are in TB Basics information page")
                } else if (phrases[0].includes("update") || phrases[0].includes("Update") || phrases[0].includes("news")) {

                  that.speakText("Here you can view latest news from Stop TB Partnership")
                } else if (phrases[0].includes("people affected by TB tab") || phrases[0].includes("second tab") || phrases[0].includes("tab 2") || phrases[0].includes("tap 2")) {
                  that.speakText("You're on people affected by TB tab")
                } else if (phrases[0].includes("medical expert") || phrases[0].includes("first tab") || phrases[0].includes("tab 1") || phrases[0].includes("tap 1")) {
                  that.speakText("You're on medical expert tab")
                } else if (phrases[0].includes("message") || phrases[0].includes("survivor") || phrases[0].includes("video")) {
                  that.speakText("Here you can view messages from TB survivors")
                }
              } else if (triggerQAFlag === true) {
                console.log("that.state.phrases", that.state.QAphrases);
                that.speakText(that.state.QAphrases[phrases[0]])
                // window.SpeechKITT.abortRecognition()
                that.state.QAphrases.map((comp) => {
                  //this.state.phrases[0].talkBackBasedOnQuestions["what is tb"]
                  for (let str of Object.keys(comp.talkBackBasedOnQuestions)) {
                    console.log("PString 2", str)
                    console.log("Comp 2::", comp)
                    console.log("phrases[0]::", phrases[0])
                    if (str.includes(phrases[0])) {
                      let text = comp.talkBackBasedOnQuestions[str];
                      console.log("speakText text", text);
                      that.speakText(text);
                      break;
                    }
                  }
                })
              } else if (phrases[0].includes("call") || phrases[0].includes(that.state.emergencyContactsList.relation)) {
                that.speakText("calling " + that.state.emergencyContactsList.relation);
                window.plugins.CallNumber.callNumber((res) => { console.log("succes", res) }, (res) => { console.log("err", res) }, that.state.emergencyContactsList.contactNumber, true);
              }
              else if (phrases[0].includes("call") || phrases[0].includes(that.state.emergencyContactsList.relation)) {
                that.speakText("calling " + that.state.emergencyContactsList.relation);
                window.plugins.CallNumber.callNumber((res) => { console.log("succes", res) }, (res) => { console.log("err", res) }, that.state.emergencyContactsList.contactNumber, true);
              } else if (localStorage.getItem('awaitAnswer') && phrases[0].includes("survey") && (phrases[0].includes("don't want") || phrases[0].includes("close") || phrases[0].includes("stop") || phrases[0].includes("terminate") || phrases[0].includes("end") || phrases[0].includes("exit") || phrases[0].includes("quit"))) {
                that.speakText("Your survey has been saved successfully. Is there anything else I can help you with?");
                localStorage.removeItem('awaitAnswer');
              } else if (localStorage.getItem('awaitAnswer') && localStorage.getItem('awaitAnswer') == 'false') {
                var temp = JSON.parse(localStorage.getItem('botSQ'));
                console.log("keshika look here", that.state.serviceDetails[temp].questionnaire[0].title)
                that.askSurveyQuestion(temp);
                // localStorage.setItem('botSQ', temp++);
                localStorage.setItem('awaitAnswer', true);
              } else if (localStorage.getItem('awaitAnswer') && localStorage.getItem('awaitAnswer') == 'true') {
                var tempForm = JSON.parse(localStorage.getItem('botSA'));
                var temp = JSON.parse(localStorage.getItem('botSQ'));
                console.log("temp before::", temp)
                tempForm[that.state.serviceDetails[temp].questionnaire[0].id] = phrases[0];
                localStorage.setItem('botSA', JSON.stringify(tempForm));
                if (that.verifyUserResponse(temp, phrases[0])) {
                  tempForm[that.state.serviceDetails[temp].questionnaire[0].id] = that.getOptionValue(temp, phrases[0]);
                  localStorage.setItem('botSA', JSON.stringify(tempForm));
                  temp++;
                }
                console.log("temp after::", temp)
                localStorage.setItem('botSQ', temp);
                if (JSON.parse(localStorage.getItem('botSQ')) == (that.state.serviceDetails.length)) {
                  that.speakText("Thank you for your responses");
                  console.log("Final Survey Res", localStorage.getItem('botSA'));
                  that.handleSubmit(JSON.parse(localStorage.getItem('botSA')));
                  localStorage.removeItem("awaitAnswer")
                  localStorage.removeItem("botSA")
                  localStorage.removeItem("botSQ")
                } else {
                  that.askSurveyQuestion(temp);
                }
              } else {
                if (phrases[0].includes("change language")) {
                  that.changeBotLanguage('hi_IN');
                } else {
                  that.handleNewUserMessage(phrases[0]);
                  that.setState({
                    messageType: 'voice'
                  });
                }
              }
            }
          }, function (err) {
            console.error(err);
          }, STTSettings);
          if(window.cordova.platformId == 'ios'){
            setTimeout(function(){
              that.stopRecognition();
            },4000);
          }
        } else {
          window.plugins.speechRecognition.requestPermission(function () {


          }, function (err) {
            console.log(err);
          })
        }
      }, function (notGranted) {
        that.setState({ micActive: false });
        window.plugins.speechRecognition.requestPermission(
          function (y) { console.log('y', y) }, function (y) { console.log('N', y) })
      });
    }
  }

  getAppLogos() {
    var that = this
    if (navigator.onLine) {
      OffileDb.getData('applogos').then(function (result) {
        if (!result.status && result.status != 404) {
          let bogo = result.data.brandingDetails.filter(o => o.tagline == "backgroundlogo").map(o => o.icon)[0] || imgUrl.logo;
          that.setState({
            bglogo: bogo,
          });
        }
      });
    }
  }

  updateFcmId() {
    var param = {
      communityId: this.props.communityuid,
      userId: JSON.parse(localStorage.getItem("obj")).userId,
      fcmId: localStorage.getItem("fcmToken"),
    };
    console.log("updateFcmId>>", param, JSON.stringify(param));

    Services.updateFcmId(param).then((data) => {
      console.log("addApplicant>>", data);
    })
  }

  isVoiceBotEnabled() {

    var param = {
      communityId: this.props.communityuid
    };
    console.log("isVoiceBotEnabled>>", param, JSON.stringify(param));
    var that = this;

    Services.getVoicBotStatus(param).then((data) => {
      console.log("isVoiceBotEnabled>>", data.data.data.isVoiceBotEnabled);
      console.log("isVoiceBotEnabled>>", data.data.data.voiceBotEnabledLanguages);
      data.data.data.voiceBotEnabledLanguages.map((item) => {
        console.log("item::", item);
        if (item.locale == localStorage.getItem('i18nextLng')) {
          console.log("item.rasaBotLanguageUrls", item.rasaBotLanguageUrls);
          that.setState({
            botUrl: item.rasaBotLanguageUrls
          })
        }
      })
      that.setState({
        botLocale: localStorage.getItem('i18nextLng').split('_').join('-')
      })
      // if(localStorage.getItem('CommunityId') == '3a3c69c8c7006b8c670e6fcd06df2d57'){
      //   that.setState({
      //     botUrl: 'https://76f6dca010e8.ngrok.io/webhooks/rest/webhook'
      //   })
      // }else{
      //   if(localStorage.getItem('i18nextLng') == 'hi_IN'){
      //     that.setState({
      //       botUrl: 'https://d56fad9b4087.ngrok.io/webhooks/rest/webhook'
      //     })
      //   }else{
      //     that.setState({
      //       botUrl: 'https://5bba9b674e5a.ngrok.io/webhooks/rest/webhook'
      //     })
      //   }
      // }

      if (data.data && data.data.data && data.data.data.isVoiceBotEnabled) {
        that.setState({
          showBot: data.data.data.isVoiceBotEnabled
        })
        // that.fakeStartRecognition();
        if (localStorage.getItem('isGreeted') == "false") {
          // that.speakText("Hi! welcome")
          localStorage.setItem('isGreeted', "true");
        }
        if (/*annyang && */localStorage.getItem('BotInnit') == "false") {
          // annyang.setLanguage("en_US");
          // window.SpeechKITT.setStylesheet('../assets/css/flat.css');
          // window.SpeechKITT.setInstructionsText('Say hello!');
          // Render interface

          // window.SpeechKITT.setStartCommand(function () { that.startRecognition() });
          // window.SpeechKITT.setAbortCommand(function () { that.stopRecognition() });
          // window.SpeechKITT.vroom();

          that.getPhrases();
          that.getTriggerWords();
        }
      } else {
        // window.SpeechKITT.hide();
      }
    })
  }

  changeBotLanguage(locale) {
    var param = {
      communityId: this.props.communityuid
    };
    var that = this;

    Services.getVoicBotStatus(param).then((data) => {
      console.log("isVoiceBotEnabled>>", data.data.data.isVoiceBotEnabled);
      console.log("voiceBotEnabledLanguages>>", data.data.data.voiceBotEnabledLanguages);
      data.data.data.voiceBotEnabledLanguages.map((item) => {
        console.log("item::", item);
        if (item.locale == locale) {
          console.log("item.rasaBotLanguageUrls", item.rasaBotLanguageUrls);
          that.setState({
            botUrl: item.rasaBotLanguageUrls
          })
        }
      })
      that.setState({
        botLocale: locale.split('_').join('-')
      })
      // if(localStorage.getItem('CommunityId') == '3a3c69c8c7006b8c670e6fcd06df2d57'){
      //   that.setState({
      //     botUrl: 'https://76f6dca010e8.ngrok.io/webhooks/rest/webhook'
      //   })
      // }else{
      //   if(localStorage.getItem('i18nextLng') == 'hi_IN'){
      //     that.setState({
      //       botUrl: 'https://d56fad9b4087.ngrok.io/webhooks/rest/webhook'
      //     })
      //   }else{
      //     that.setState({
      //       botUrl: 'https://5bba9b674e5a.ngrok.io/webhooks/rest/webhook'
      //     })
      //   }
      // }

      if (data.data && data.data.data && data.data.data.isVoiceBotEnabled) {
        if (localStorage.getItem('isGreeted') == "false") {
          // that.speakText("Hi! welcome")
          localStorage.setItem('isGreeted', "true");
        }
        if (/*annyang && */localStorage.getItem('BotInnit') == "false") {
          // annyang.setLanguage("en_US");
          // window.SpeechKITT.setStylesheet('../assets/css/flat.css');
          window.SpeechKITT.setInstructionsText('Say hello!');
          // Render interface

          window.SpeechKITT.setStartCommand(function () { that.startRecognition() });
          window.SpeechKITT.setAbortCommand(function () { that.stopRecognition() });
          window.SpeechKITT.vroom();

          that.getTriggerWords();
          that.getPhrases();

        }
      } else {
        window.SpeechKITT.hide();
      }
    })
  }

  // isVoiceBotEnabled(){
  //   var param = {
  //     communityId: this.props.communityuid
  //   };
  //   console.log("isVoiceBotEnabled>>", param, JSON.stringify(param));
  //   var that = this;

  //   Services.getVoicBotStatus(param).then((data) => {
  //     console.log("isVoiceBotEnabled>>", data.data.data.isVoiceBotEnabled);
  //     if(data.data.data.isVoiceBotEnabled){
  //       window.SpeechKITT.vroom();
  //       window.SpeechKITT.setStartCommand(function() {if(window.cordova) {
  //         var STTSettings = {
  //             language: 'en_US',
  //             showPopup: false
  //         };
  //         window.plugins.speechRecognition.startListening(function(phrases){
  //           if(phrases != null && phrases.length > 0){
  //             var message = phrases[0].toLowerCase();
  //             phrases[0] = message;
  //             console.log('Speech recognized2 : ' + phrases[0]);
  //             var triggerFlag = false;
  //             console.log('Speech recognized33 : ', that.state);
  //             var triggerWords = that.state.triggerWords;
  //             for(var str of triggerWords) {
  //               console.log('Speech recognized5 : ');
  //               if(phrases[0].includes(str)){
  //                   triggerFlag = true;
  //               }
  //             }
  //             console.log("triggerFlag", triggerFlag);
  //             if(triggerFlag === true) {
  //               let list = that.state.menuList;
  //               list.map((menu) => {
  //                 console.log("menu.visible", menu.visible);
  //                 if (menu.isactive) { //replaced visible with isactive 
  //                   that.state.phrases.map((comp) => {
  //                     console.log("comp, menu", comp, menu);
  //                     if(comp.componentName == menu.name){ //compared name instead of id
  //                       console.log("component matched");
  //                       for(var str of comp.phrases) {
  //                         if(phrases[0].includes(str)) {
  //                           that.props.setSelectedComponentObject({id: comp.componentId, name: comp.name}); //menu.componentId causing issue
  //                           that.props.setBottomNavComponentObject({id: comp.componentId, name: comp.name});
  //                           if(localStorage.getItem("templateID")==2){
  //                             that.props.history.push("/layout2/"+menu.path);
  //                           } else {
  //                             that.props.history.push("/layout/"+menu.path);
  //                             // that.props.history.push("/layout/getknowledgeable");
  //                           }
  //                           that.speakText("There you go!")
  //                         }
  //                       }
  //                     }
  //                   })
  //                 } else {
  //                   menu.childs.map((submenu) => {
  //                     if (submenu.visible) {
  //                       that.state.phrases.map((comp) => {
  //                         if(comp.name == submenu.name){
  //                           for(var str of comp.phrases) {
  //                             if(phrases[0].includes(str)) {
  //                               that.props.setSelectedComponentObject({id: submenu.componentId, name: submenu.name});
  //                               that.props.setBottomNavComponentObject({id: submenu.componentId, name: submenu.name});
  //                               if(localStorage.getItem("templateID")==2){
  //                                 that.props.history.push("/layout2/"+submenu.path);
  //                               } else {
  //                                 that.props.history.push("/layout/"+submenu.path);
  //                               }
  //                               that.speakText("There you go!")
  //                             }
  //                           }
  //                         }
  //                       })
  //                     }
  //                   });
  //                 }
  //               });
  //               console.log("phrases[0]", phrases[0]);
  //               if (phrases[0].includes("setting")) {
  //                 if(localStorage.getItem("templateID")==2){
  //                   that.props.history.push({ pathname: `/layout2/settings`, name: "Settings" });
  //                 } else {
  //                   that.props.history.push({ pathname: `/layout/settings`, name: "Settings" });
  //                 }
  //                 that.speakText("There you go!")
  //               } else if (phrases[0].includes("home")) {
  //                 localStorage.setItem('BotInnit', "true");
  //                 if(localStorage.getItem("templateID")==2){
  //                   that.props.history.push("/layout2");
  //                 } else {
  //                   that.props.history.push("/layout");
  //                 }
  //                 that.speakText("You're back on the Homepage.")

  //               } else if (phrases[0].includes("back")) {
  //                 switch (that.props.history.location.pathname) {
  //                   case '/layout/knowyourrights':
  //                     if(localStorage.getItem("templateID")==2){
  //                       localStorage.setItem('BotInnit', "true");
  //                       that.props.history.push("/layout2");
  //                     } else {
  //                       that.props.history.push("/layout");
  //                     }

  //                     break;
  //                   case '/layout/getknowledgeable':
  //                     if(localStorage.getItem("templateID")==2){
  //                       localStorage.setItem('BotInnit', "true");
  //                       that.props.history.push("/layout2");
  //                     } else {
  //                       that.props.history.push("/layout");
  //                     }

  //                     break;
  //                   case '/layout/information':
  //                     if(localStorage.getItem("templateID")==2){
  //                       localStorage.setItem('BotInnit', "true");
  //                       that.props.history.push("/layout2");
  //                     } else {
  //                       that.props.history.push("/layout");
  //                     }

  //                     break;
  //                   case '/layout/nearme':
  //                     if(localStorage.getItem("templateID")==2){
  //                       localStorage.setItem('BotInnit', "true");
  //                       that.props.history.push("/layout2");
  //                     } else {
  //                       that.props.history.push("/layout");
  //                     }

  //                     break;
  //                   case '/layout/peerchat':
  //                     if(localStorage.getItem("templateID")==2){
  //                       localStorage.setItem('BotInnit', "true");
  //                       that.props.history.push("/layout2");
  //                     } else {
  //                       that.props.history.push("/layout");
  //                     }

  //                     break;
  //                   case '/layout/services':
  //                     if(localStorage.getItem("templateID")==2){
  //                       localStorage.setItem('BotInnit', "true");
  //                       that.props.history.push("/layout2");
  //                     } else {
  //                       that.props.history.push("/layout");
  //                     }

  //                     break;
  //                   default:
  //                     that.props.history.goBack();
  //                     break;
  //                 }
  //                 that.speakText("Alright!");
  //               } else if(phrases[0].includes("basic")) {
  //                 that.props.setSelectedComponentObject({name: "Get Information", id: 51});
  //                 that.props.setBottomNavComponentObject({name: "Get Information", id: 51});
  //                 if(localStorage.getItem("templateID")==2){
  //                   that.props.history.push("/layout2/getknowledgeable");
  //                 } else {
  //                   that.props.history.push("/layout/getknowledgeable");
  //                 }
  //                 that.speakText("You are in TB Basics information page")
  //               } else if(phrases[0].includes("update") || phrases[0].includes("Update") || phrases[0].includes("news")) {

  //                 that.speakText("Here you can view latest news from Stop TB Partnership")
  //               } else if(phrases[0].includes("people affected by TB tab") || phrases[0].includes("second tab") || phrases[0].includes("tab 2") || phrases[0].includes("tap 2")){
  //                 that.speakText("You're on people affected by TB tab")
  //               } else if(phrases[0].includes("medical expert") || phrases[0].includes("first tab") || phrases[0].includes("tab 1") || phrases[0].includes("tap 1")){
  //                 that.speakText("You're on medical expert tab")
  //               }else if(phrases[0].includes("message") || phrases[0].includes("survivor") || phrases[0].includes("video")) {
  //                 that.speakText("Here you can view messages from TB survivors")
  //               }
  //             }
  //             else{



  //             var messageObj = {};
  //             // console.log('User identification hardcoded - use unique user identification for go live - like iMonitor+ User ID / Users Phone Number.');
  //             // messageObj.sender ="32423423423";  // To replace with unique user IDENTITY like iMonitor+ User ID / User's Phone Number.
  //               if(JSON.parse(localStorage.getItem("obj")).userId) {
  //               messageObj.sender = JSON.parse(localStorage.getItem("obj")).userId;  // To replace with unique user IDENTITY like iMonitor+ User ID / User's Phone Number.
  //                     } else {
  //               messageObj.sender = "32423423423";
  //                     }
  //                     messageObj.message = phrases[0];
  //                     var responseText = "";
  //                     window.axios(
  //                   {
  //                     method: 'post',
  //                     url: 'https://4a6f54f8ad57.ngrok.io/webhooks/rest/webhook',  // FOR WEBSITE HOSTING USE THIS URL
  //                     // url: 'http://6aa20bb86102.ngrok.io/webhooks/rest/webhook ',  // FOR LOCAL HOST DEVELOPMENT USE THIS URL
  //                     data: messageObj
  //                   }).then(function (response) {

  //                     var i;
  //                     for(i = 0 ; i < response.data.length; i++)
  //                     {
  //                       responseText = responseText + response.data[i].text;
  //                     }

  //                     //console.log(responseText);
  //                   //   SpeechKITT.abortRecognition(); // Stop listening while the bot processes data and speaks
  //                     that.speakText(responseText);
  //                   });  
  //                 }
  //                 annyang.abort();
  //             }
  //         }, function(err){
  //           console.error(err);
  //       }, STTSettings);
  //     }});
  //       window.SpeechKITT.setAbortCommand(function() {
  //         if(window.cordova) {
  //           window.plugins.speechRecognition.stopListening(function(){
  //               // No more recognition
  //           }, function(err){
  //               console.log(err);
  //           });
  //       }
  //       });
  //     }

  //   })
  // }

  getPhrases() {
    // this.loadOfflineMeunLabel();
    // if (navigator.onLine) {
    var params = {
      communityId: this.props.communityuid,
      languageId: this.props.langId
    };
    Services.getPhrasesForVoiceBot(params).then((res) => {
      if (res.data.status == 200) {
        this.setState(
          {
            phrases: res.data.data,
          }
        );
   
        // OffileDb.setData("MenuLabel", res.data.data.label);
      }
    });
    // }
  }
  getEmergencyContacts() {
    // this.loadOfflineMeunLabel();
    // if (navigator.onLine) {
    var params = {
      userId: JSON.parse(localStorage.getItem("obj")).userId,
    };
    Services.getEmergencyContacts(params).then((res) => {
 
      if (res && res.data && res.data.data && res.data.status == 0) {
        this.setState(
          {
            emergencyContactsList: res.data.data.emergencyContacts[0],
          }
        );

        // OffileDb.setData("MenuLabel", res.data.data.label);
      }
    });
    // }
  }
  getTriggerWords() {
    // this.loadOfflineMeunLabel();
    // if (navigator.onLine) {
    var params = {
      communityId: this.props.communityuid,
      languageId: this.props.langId
    };
    Services.getTriggerWordsForVoiceBot(params).then((res) => {
      if (res.data.status == 200) {
        this.setState(
          {
            triggerWords: res.data.data.triggerWords,
          }
        );
     
        // OffileDb.setData("MenuLabel", res.data.data.label);
      }
    });
    // }
  }

  getMenuList() {
    this.loadOfflineMeunList();
  }

  getMenuApiList() {
    if (navigator.onLine) {
      var params = {
        communityId: this.props.communityuid,
        componentId: 0,
        roleId: JSON.parse(localStorage.getItem("obj")).roleId,
      };
      Services.getComponentWiseRoleDetails(params).then((res) => {
        if (res.data.status == 200) {
          this.setState(
            {
              menuList: res.data.data.componentList.mobileSections,
              isLoading: false
            },
            () => {
              this.callTourGuide(res.data.data.componentList.mobileSections)

            }
          );
          localStorage.setItem("menuList", JSON.stringify(res.data.data.componentList.mobileSections));
          OffileDb.setData("MenuList", res.data.data.componentList.mobileSections);
        }
      });
    }
  }

  callTourGuide(list) {
    var menuarr = []
    const { templateID } = this.props;
    list.map((menu) => {
      if (menu.visible) {
        menuarr.push(menu.name)
      } else {
        menu.childs.map((submenu) => {
          if (submenu.visible) {
            menuarr.push(submenu.name)
          }
        });
      }
    });

    if (templateID == 1) {
      menuarr.push('Settings')
    }

    this.props.setTourGuide(menuarr);
  }

  getTranlation(id) {
    this.loadOfflineMeunLabel();
    if (navigator.onLine) {
      var params = {
        communityId: this.props.communityuid,
        labelType: 'Mobile',
        languageId: id,
      };
      Services.getCommunitywiseLabels(params).then((res) => {
        if (res.data.status == 200) {
          this.setState(
            {
              translationLabel: res.data.data.label,
            },
            () => this.getMenuList()
          );
          OffileDb.setData("MenuLabel", res.data.data.label);
        }
      });
    }
  }

  loadOfflineMeunList() {
    var that = this;
    OffileDb.getData("MenuList").then(function (result) {
      if (!result.status && result.status != 404) {
        that.setState({
          menuList: result.data,
          isLoading: false
        });
        localStorage.setItem("menuList", JSON.stringify(result.data));
        that.callTourGuide(result.data)
      } else {
        that.getMenuApiList();
      }
    });
  }

  loadOfflineMeunLabel() {
    var that = this;
    OffileDb.getData("MenuLabel").then(function (result) {
      if (!result.status && result.status != 404) {
        that.setState({
          translationLabel: result.data,
        });
        that.getMenuList();
      }
    });
  }

  componentWillUnmount() {
    // this.setState({
    //   menuList: []
    // })
  }

  handleClick = (menuobj) => {
    const { t } = this.props;
    //setOpen(!open);
    if (!navigator.onLine && (menuobj.state.id == 25)) {
      swal({
        title: t("You are currently offline."),
        icon: "error",
        button: "Ok",
      })
    } else {
      if(window.cordova && menuobj.pathname == "/layout/nearme"){
        var self = this;
        window.CheckGPS.check(function(){
          //GPS is enabled!
          localStorage.setItem('componentbgcolor', menuobj.state.componentbgcolor)
          self.props.setcomponentbgcolor(menuobj.state.componentbgcolor)
          self.props.setSelectedComponentObject(menuobj.state);
          self.props.setBottomNavComponentObject(menuobj.state);
          self.props.history.push(menuobj.pathname);
        },
        function(){
          //GPS is disabled!
          swal({
            text: t("Please turn on your location/GPS"),
            icon: "warning",
            button: t("ok"),
          })
        });
      }else{
              //console.log("menuObj", menuobj.state.componentbgcolor)
        localStorage.setItem('componentbgcolor', menuobj.state.componentbgcolor)
        this.props.setcomponentbgcolor(menuobj.state.componentbgcolor)
        this.props.setSelectedComponentObject(menuobj.state);
        this.props.setBottomNavComponentObject(menuobj.state);
        this.props.history.push(menuobj.pathname);
      }
    }

  };

  mountMenu(menu, menuiconobj) {
    const { templateID } = this.props;
    if (templateID == 1) {
      return this.tempalte1Menu(menu, menuiconobj)
    } if (templateID == 2) {
      return this.tempalte2Menu(menu, menuiconobj)
    }
  }

  getGridLen(count) {
    //let menufilter = this.state.menuList.filter(obj => (obj.visible && obj.isactive) || (obj.path == "information" && obj.childs.filter(subobj => subobj.visible && subobj.isactive).lenght > 0));

    let menufilter = this.state.menuList.filter(function (e) {
      return ((e.visible && e.isactive) || (e.path == "information" && e.childs.filter(function (sub) {
        return sub.visible && sub.isactive
      })))
    });
    var gridleng = 6;
    if (menufilter.length == 1 || menufilter.length == 2 || menufilter.length == 3) {
      gridleng = 12
    } else if (menufilter.length == 4 &&  count == menufilter.length - 1 ) {
      gridleng = 12
    } else if (count == 0 && menufilter.length > 3) {
      gridleng = menufilter.length % 2 == 0 ? 12 : 6;
    }
    return gridleng;
  }




  tempalte1Menu(menu, menuiconobj) {
    var gridleng = this.getGridLen(count)
    const { t } = this.props;
    const { translationLabel } = this.state;
    let menuContent = [];
    if (!translationLabel || Object.keys(translationLabel).length == 0) {
      return menuContent;
    }
    let name = menu.label;
    let calss = menu.label.split(" ").join("");
    if (menu.layout != null) {
      // var spliurtl = menu.icon.split("://")
      // let myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
      let menuicon = this.getMenuIcon(menu)
      menuContent.push(
        <Grid item xs={gridleng}>
          <Link
            key={menu.componentId}
            name={t(name)}
            onClick={() =>
              this.handleClick({
                pathname: `/layout/${menu.path}`,
                state: {
                  name: name,
                  id: menu.componentId,
                  componentbgcolor: menu.layout.componentbgcolor,
                },
              })
            }
            className={calss}
          >
            <div className="homepagegrid_bgmenu" >
              <p className="zero vertical-align-center">
                {menuicon}
              </p>
              <p className="zero vertical-align-center">{t(name)}</p>
            </div>
          </Link>
        </Grid >
      )
      count++;
    }
    return menuContent;

  }

  tempalte2Menu(menu, menuiconobj) {
    const { t } = this.props;
    const { translationLabel } = this.state;
    let menuContent = [];
    if (!translationLabel || Object.keys(translationLabel).length == 0) {
      return menuContent;
    }
    let name = menu.label;
    let calss = menu.label.split(" ").join("");
    //if (menuiconobj[menu.id] != undefined) {
    if (menu.layout != null) {
      // var spliurtl = menu.icon.split("://")
      // let myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
      let menuicon = this.getMenuIcon(menu)
      menuContent.push(
        <Link
          key={menu.componentId}
          name={t(name)}
          onClick={() =>
            this.handleClick({
              pathname: `/layout/${menu.path}`,
              state: {
                name: name,
                id: menu.componentId,
                componentbgcolor: menu.layout.componentbgcolor,
              },
            })
          }
          className={calss}
        >
          <Zoom in style={{ transitionDelay: checked ? "0ms" : "300ms" }}>
            <ListItem button className="homemenu-linkbtn" style={{ backgroundColor: menu.layout.componentbgcolor }}>
              <ListItemIcon className="homemenuicon home-list-icon" style={{ backgroundColor: menu.layout.iconbgcolor }}>
                {
                  menuicon
                }
              </ListItemIcon>
              <Trans>
                <ListItemText
                  primary={t(name)}
                  className="homemenutext capitalize"
                />
              </Trans>
            </ListItem>
          </Zoom>
        </Link>
      );
    }
    return menuContent;
  }
  handleNewUserMessage = (newMessage) => {
    try {
      var that = this;

      if (that.state.messageType == 'voice') {
        addUserMessage(newMessage);
      }
  
      var messageObj = {};
      if (JSON.parse(localStorage.getItem("obj")).userId) {
        messageObj.sender = JSON.parse(localStorage.getItem("obj")).userId;  // To replace with unique user 
      } else {
        messageObj.sender = "152828";
      }
      messageObj.message = newMessage;
      var responseText = "";
      // window.axios(
      //   {
      //     method: 'post',
      //     // url: 'https://uat.care.preventtb.org/imonservice/api/imonitor/rasa/chatbot/mywebhook',  // FOR WEBSITE HOSTING USE THIS URL
      //     url: that.state.botUrl,  // FOR WEBSITE HOSTING USE THIS URL
      //     data: messageObj
      //   }).then(function (response) {

      //     var i;
      //     for (i = 0; i < response.data.length; i++) {
      //       responseText = responseText + response.data[i].text;
      //     }
      //     addResponseMessage(responseText);
      //     that.speakText(responseText);
      //   });
      var botParams = {
        url: that.state.botUrl,
        text: messageObj
      }

      that.setState({ micActive: false });
      Services.getRasaResponse(botParams).then((response) => {
      
        if (response.status && response.status == 200) {
          console.log(response);
          var i;
          for (i = 0; i < response.data.length; i++) {
            responseText = responseText + response.data[i].text;
          }
          addResponseMessage(responseText);
          if (that.state.messageType == 'voice') {
            this.setState({
              botResponse: responseText,
              showBotText: true,
              messageType: ''
            })
          }
          that.speakText(responseText);
        } else {
          console.log('err')
        }
      })

    } catch (e) {
      console.log("error::", e);
    }

  }

  toggleMicClass() {
    if (window.cordova) {
      const currentBotState = this.state.micActive;
      this.setState({ micActive: !currentBotState });
      console.log("this.state.micActive", this.state.micActive)
      if (this.state.micActive == false) {
        this.setState({ micActive: true });
        this.startRecognition();
      } else {
        this.setState({ micActive: false });
        this.stopRecognition();
      }
    }
  };

  getMenuIcon(menu) {
    if (menu.className) {
      return <i className={"demo-icon " + menu.className}></i>
    } else if (menu.icon != "") {
      let myUrl = this.getHttpsUrl(menu.icon)
      return <img className="img-fluid" src={myUrl} />
    } else {
      return <InfoIcon />
    }
  }

  getHttpsUrl(iconurl) {
    var spliurtl = iconurl.split("://")
    let myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
    return myUrl;
  }

  closeBotText() {
    console.log("closeBotText");
    this.setState({
      showBotText: false
    });
  }


  render() {
    const { t } = this.props;
    const { templateID } = this.props;
    let list = this.state.menuList;
    let menuiconobj = this.state.menuiconobj;
    var menuContent = [];
    count = 0;
    list.map((menu, i) => {
      if (menu.visible && menu.isactive && menu.path != "settings") {
        menuContent.push(this.mountMenu(menu, menuiconobj));
      } else if (menu.path == "information") {
        menu.childs.map((submenu) => {
          if (submenu.visible && submenu.isactive) {
            menuContent.push(this.mountMenu(submenu, menuiconobj));
          }
        });
      }
    });

    menuContent = menuContent.filter(obj => obj.length > 0);
    var gridleng = menuContent.length == 1 || menuContent.length == 2 ? 12 : 6;
    //var gridleng = menuContent.length%2 == 0 ? 12 : 6;
    let sobj = this.state.menuList.filter(obj => obj.path == "settings")
    let settingicon = imgUrl.settings
    if (sobj.length > 0) {
      settingicon = sobj[0]['icon'] ? this.getHttpsUrl(sobj[0]['icon']) : imgUrl.settings;

    }

    return (
      <>
        {this.state.isLoading && <Loader isLoading={this.state.isLoading} />}
        {
          templateID == 1 ? (
            <Grid container spacing={3} className="gridcontainer">
              <Grid item xs={12}>
                <div className="text-center homepagegridmaindiv">
                  <Grid container spacing={3} className="gridcontainer homepagegridinnerdiv">
                    {menuContent}
                    {/* {
                      menuContent.length > 1 && menuContent.length <= 5 &&
                      <Grid item xs={gridleng}>
                        <Link
                          key={12}
                          name={t('Settings')}
                          className="Settings"
                          onClick={() =>
                            this.handleClick({
                              pathname: `/layout/settings`,
                              state: {
                                name: 'settings',
                                id: '12',
                                componentbgcolor: "#000",
                              },
                            })
                          }
                        >
                          <div className="homepagegrid_bgmenu">
                            <p className="zero vertical-align-center">
                              <SettingsIcon style={{ fontSize: 40 }}></SettingsIcon>
                            </p>
                            <p className="zero vertical-align-center">{t('Settings')}</p>
                          </div>
                        </Link>
                      </Grid >
                    } */}
                  </Grid>
                  <div className={this.state.showBot ? 'shown' : 'hide'}>
                    <Widget
                      handleNewUserMessage={this.handleNewUserMessage}
                      title="Lisa"
                      subtitle="Chatbot"
                      profileAvatar={logo}
                    />
                    <div style={{ position: 'absolute', bottom: '130px', right: '28px' }}>
                      <div className={this.state.micActive ? 'active speech-btn' : 'speech-btn'} onClick={() => this.toggleMicClass()}></div>
                      {/* <div className="speech-btn" onClick={() => this.startRecognition()}></div>
                  <Link onClick={() => this.stopRecognition()}>Stop</Link> */}
                    </div>
                  </div>
                </div>
              </Grid>
              <div className={this.state.showBotText ? 'bot-spiken-text shown' : 'hide'}>
                <span class="msg-del-btn" onClick={() => this.closeBotText()}>{<CancelIcon />}</span>
                <div className="bot-inner-text">{this.state.botResponse}</div>
              </div>
            </Grid>
          ) : (
            <>
              <List component="nav" className="homemenulist homemenulisting ">
                {menuContent}
              </List>
              <div className={this.state.showBot ? 'shown' : 'hide'}>
                <Widget
                  handleNewUserMessage={this.handleNewUserMessage}
                  title="Lisa"
                  subtitle="Chatbot"
                  profileAvatar={logo}
                />
                <div style={{ position: 'absolute', bottom: '130px', right: '28px' }}>
                  <div className={this.state.micActive ? 'active speech-btn' : 'speech-btn'} onClick={() => this.toggleMicClass()}></div>
                  {/* <div className="speech-btn" onClick={() => this.startRecognition()}></div>
                  <Link onClick={() => this.stopRecognition()}>Stop</Link> */}
                </div>
              </div>
            </>
          )
        }
      </>
    );
  }
}

// export default withTranslation()(HomeMenuList);

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
  };
};

const TranslationHomeMenuList = withTranslation()(HomeMenuList);
const FinalHomeMenuList = withRouter(TranslationHomeMenuList);

export default connect(mapStateToProps, {
  setSelectedComponentObject,
  resetSelectedCompnentObject,
  setBottomNavComponentObject,
  setcomponentbgcolor
})(FinalHomeMenuList);
